export default __webpack_public_path__ + "static/media/K2D-SemiBold.986d97c3.ttf";